import { entities } from 'pages/store/schema';
import { getValue, getValues } from 'pages/store/selectors';

import get from 'lodash/get';
import filter from 'lodash/filter';

export const getCCTerminalByGatewayConfigID = gatewayConfigID => state =>
  filter(
    getValues(entities.ccTerminal)(state),
    ccTerminal => get(ccTerminal, 'gatewayConfigID') === gatewayConfigID
  );

export const getTeminalLastUsedShop = terminalID => state => {
  const shops = getValues(entities.shop)(state);
  const terminal = getValue(entities.ccTerminal, terminalID)(state);

  return find(shops, shop => get(shop, 'shopID') === get(terminal, 'shopID'));
};

export default getCCTerminalByGatewayConfigID;
